/* Lineup slider: the chosen safe sits centre stage, its neighbours peek in from the sides, and everything moves on one
   snappy ease. Tabs, arrow keys, a tap on a neighbour, and a swipe all go through select(). */
(function () {
  /* Elite / Basic / bundle switch inside a card or tile: swap name, facts, price and the button's target from its JSON */
  function bindVersions(c) {
    if (c.bsVersions) return; c.bsVersions = true;
    var data = c.querySelector('[data-bs-versions]'); if (!data) return;
    var d; try { d = JSON.parse(data.textContent); } catch (e) { return; }
    var pills = [].slice.call(c.querySelectorAll('[data-bs-ver]'));
    pills.forEach(function (p) {
      p.addEventListener('click', function () {
        var v = d[p.getAttribute('data-bs-ver')]; if (!v) return;
        pills.forEach(function (q) { q.setAttribute('aria-pressed', q === p); });
        var q = function (sel) { return c.querySelector(sel); };
        if (q('[data-bs-rname]')) q('[data-bs-rname]').innerHTML = v.name_html;
        if (q('[data-bs-rfacts]')) q('[data-bs-rfacts]').innerHTML = v.facts_html;
        if (q('[data-bs-rprice]')) q('[data-bs-rprice]').innerHTML = v.price_html;
        if (q('[data-bs-rfour]')) q('[data-bs-rfour]').innerHTML = v.four;   // carries the sale/regular spans during a sale
        if (q('[data-bs-rrating]')) q('[data-bs-rrating]').innerHTML = v.rating_html || '';
        var b = q('[data-bs-rbtn]'); if (b) { b.href = v.href; b.textContent = v.button; }
        var l = q('[data-bs-rlink]'); if (l) { l.href = v.href; }
        var st = q('[data-bs-rstack]'); if (st && v.stack_html) st.innerHTML = v.stack_html;   // the stack follows the version
        var tm = q('[data-bs-rterms]'); if (tm && v.terms_html) tm.innerHTML = v.terms_html;   // and so does Shop Pay's line
      });
    });
  }
  function setup(root) {
    if (root.bsRange) return; root.bsRange = true;
    var view = root.querySelector('.bs-range-view'), track = root.querySelector('.bs-range-track'),
        slides = [].slice.call(root.querySelectorAll('.bs-range-slide')), tabs = [].slice.call(root.querySelectorAll('[role="tab"]')),
        cards = [].slice.call(root.querySelectorAll('.bs-range-card')), pill = root.querySelector('.bs-range-pill'),
        tabbar = root.querySelector('.bs-range-tabs'), n = slides.length, cur = Math.min(n - 1, parseInt(root.getAttribute('data-start'), 10) || 0);
    if (!n) return;
    function offsetFor(i) { var s = slides[i]; return view.clientWidth / 2 - (s.offsetLeft + s.offsetWidth / 2); }
    function place(extra) { track.style.transform = 'translate3d(' + (offsetFor(cur) + (extra || 0)) + 'px,0,0)'; }
    function movePill() { var t = tabs[cur]; if (!pill || !t) return; pill.style.width = t.offsetWidth + 'px'; pill.style.transform = 'translateX(' + t.offsetLeft + 'px)'; }
    function select(i, focus) {
      cur = (i + n) % n;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === cur); });
      cards.forEach(function (c, k) { c.classList.toggle('is-active', k === cur); if (k === cur) c.removeAttribute('inert'); else c.setAttribute('inert', ''); });
      tabs.forEach(function (t, k) { t.setAttribute('aria-selected', k === cur); t.tabIndex = k === cur ? 0 : -1; });
      place(); movePill();
      var t = tabs[cur];
      if (t && tabbar.scrollWidth > tabbar.clientWidth) tabbar.scrollTo({ left: t.offsetLeft - (tabbar.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
      if (focus && t) t.focus({ preventScroll: true });
    }
    function still(fn) { root.classList.add('no-anim'); fn(); void track.offsetWidth; root.classList.remove('no-anim'); }   // lay out without animating
    tabs.forEach(function (t, k) {
      t.addEventListener('click', function () { select(k); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); select(cur + 1, true); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); select(cur - 1, true); }
        else if (e.key === 'Home') { e.preventDefault(); select(0, true); }
        else if (e.key === 'End') { e.preventDefault(); select(n - 1, true); }
      });
    });
    /* swipe or drag: the track follows the finger, then snaps */
    var down = false, x0 = 0, y0 = 0, dx = 0, locked = false, moved = false;
    view.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse' && e.button !== 0) return; down = true; locked = false; moved = false; x0 = e.clientX; y0 = e.clientY; dx = 0; });
    window.addEventListener('pointermove', function (e) {
      if (!down) return; dx = e.clientX - x0; var dy = e.clientY - y0;
      if (!locked) { if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return; if (Math.abs(dy) > Math.abs(dx)) { down = false; return; } locked = true; view.classList.add('is-dragging'); }
      moved = true; var edge = (cur === 0 && dx > 0) || (cur === n - 1 && dx < 0); place(edge ? dx * .35 : dx);
    });
    function up() {
      if (!down) return; down = false; view.classList.remove('is-dragging');
      var limit = Math.min(90, view.clientWidth * .12);
      if (locked && dx < -limit && cur < n - 1) select(cur + 1); else if (locked && dx > limit && cur > 0) select(cur - 1); else place();
    }
    window.addEventListener('pointerup', up); window.addEventListener('pointercancel', up);
    slides.forEach(function (s, k) { s.addEventListener('click', function () { if (!moved && k !== cur) select(k); }); });
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { still(function () { place(); movePill(); }); }, 80); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { still(movePill); });
    still(function () { select(cur); });
    cards.forEach(bindVersions);
  }
  function scan(r) { [].forEach.call((r || document).querySelectorAll('[data-bs-range]'), setup); [].forEach.call((r || document).querySelectorAll('[data-bs-versions-card]'), bindVersions); }
  scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  document.addEventListener('shopify:block:select', function (e) {   // picking a safe in the editor slides to it
    var root = e.target.closest && e.target.closest('[data-bs-range]'); if (!root) return;
    var i = e.target.getAttribute('data-i'); if (i !== null) e.target.click();
  });
})();
